import React from "react";
import PropTypes from "prop-types";

/* ============================
   Error Message & Retry Button
   ============================ */

const ErrorDisplay = ({ message, instructions, showRetry, onRetry, redundantScanInfo, onConfirmAddress, onTakePhoto }) => {
    if (!message) return null;

    const hasRedundantActions = redundantScanInfo && (redundantScanInfo.needsAddress || redundantScanInfo.needsPhoto);

    return (
        <div className="scanner-error-box">
            <div className="scanner-error-message">{message}</div>

            {instructions && (
                <div className="scanner-error-instructions">
                    {instructions}
                </div>
            )}

            {/* Action buttons for redundant scans */}
            {hasRedundantActions && (
                <div className="scanner-action-buttons">
                    {redundantScanInfo.needsAddress && (
                        <button
                            className="scanner-action-button confirm-address-btn"
                            onClick={() => onConfirmAddress(redundantScanInfo.userPath, redundantScanInfo.scanKey)}
                        >
                            Confirm Address
                        </button>
                    )}
                    {redundantScanInfo.needsPhoto && (
                        <button
                            className="scanner-action-button take-pic-btn"
                            onClick={() => onTakePhoto(redundantScanInfo.userPath, redundantScanInfo.scanKey)}
                        >
                            Take Pic
                        </button>
                    )}
                </div>
            )}

            {/* Retry button */}
            {showRetry && (
                <button
                    className="scanner-retry-button"
                    onClick={onRetry}
                >
                    Scan Again
                </button>
            )}
        </div>
    );
};

ErrorDisplay.propTypes = {
    message: PropTypes.string,
    instructions: PropTypes.string,
    showRetry: PropTypes.bool,
    onRetry: PropTypes.func,
    redundantScanInfo: PropTypes.shape({
        scanKey: PropTypes.string,
        userPath: PropTypes.string,
        needsAddress: PropTypes.bool,
        needsPhoto: PropTypes.bool,
    }),
    onConfirmAddress: PropTypes.func,
    onTakePhoto: PropTypes.func,
};

export default ErrorDisplay;
